import React, { useEffect } from 'react'
import { Head } from '@notino/react-toolkit/exports/Head'

// hooks
import useMessages from '../../../../hooks/useMessages'

const MyPassesPageHead = () => {
	const { messages } = useMessages()
	const pageTitle = messages['Your Passes']

	useEffect(() => {
		document.title = pageTitle
	}, [pageTitle])

	// NOTE: defining children as array and using .flat() on it otherwise <Head> doesn't work properly
	// each item has to have unique 'key' because <Head/> iterates over the array
	const children = [<title key='title'>{pageTitle}</title>, <meta key='robots' name='robots' content='noindex, nofollow' />].flat().filter(Boolean)

	return <Head>{children}</Head>
}

export default MyPassesPageHead
